__turbopack_context__.v({
  "inputs-wrapper": "index-module-scss-module__cjcWUq__inputs-wrapper",
  "login-button-no-terms": "index-module-scss-module__cjcWUq__login-button-no-terms",
  "section": "index-module-scss-module__cjcWUq__section",
  "terms-and-conditions-intro": "index-module-scss-module__cjcWUq__terms-and-conditions-intro",
});
